<template>
  <div class="password-edit-modal">
    <modal-frame :showModalFlag="modalDisplay" v-on:backdropClickEvent="cancelEdit">
      <div class="modal-header">
        <h1>パスワード変更</h1>
      </div>
      <div class="modal-body">
        <attribute-in-form
          :labelText="'パスワード'"
          :necessary="true"
          :validationState="validatePassword.state"
          :validationMessage="validatePassword.message"
          :attributeNotify="'半角英数字及び記号!@のみ、6文字以上120文字以下'">
          <input :type="passwordInputType" size="30" v-model="inputPassword" />
          <div class="signin_pass_toggle" @click="togglePasswordDisplay">
            <custom-check-box
              :type="'small'"
              :active="passwordDisplay"
              :enabled="true"
            />
            パスワード表示
          </div>
        </attribute-in-form>
        <attribute-in-form
          :labelText="'パスワード(確認)'"
          :necessary="false"
          :validationState="validateConfirmation.state"
          :validationMessage="validateConfirmation.message"
          :attributeNotify="''">
          <input :type="passwordInputType" size="30" v-model="passwordConfirmation"/>
        </attribute-in-form>
        <div class="form-controll">
          <button class="cancel-btn" @click="cancelEdit">キャンセル</button>
          <button class="submit-btn" :class="{ disable: !allValid }" @click="update">更新</button>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import ModalFrame from '@/components/common/ModalFrame.vue'
import AttributeInForm from '@/components/common/AttributeInForm.vue'
import CustomCheckBox from '@/components/common/CustomCheckBox.vue'

export default {
  name: 'PasswordEditModal',

  components: {
    ModalFrame,
    AttributeInForm,
    CustomCheckBox,
  },

  props: {
    targetUser: Object,
    modalDisplay: Boolean,
  },

  emits: [
    'passwordUpdateEvent',
    'cancelEvent',
  ],

  data () {
    return {
      inputPassword: '',
      passwordConfirmation: '',
      passwordDisplay: false,
    }
  },

  watch: {
    modalDisplay: { handler: 'initData', immediate: true }
  },

  computed: {
    passwordInputType () {
      if (this.passwordDisplay) {
        return 'text'
      } else {
        return 'password'
      }
    },

    validatePassword () {
      if (this.inputPassword.match(/^([a-zA-Z0-9]|!|@){6,120}$/)) {
        return { state: 'valid', valid: true, message: '' }
      } else {
        return { state: 'invalid', valid: false, message: 'パスワードの書式が正しくありません。'}
      }
    },

    validateConfirmation () {
      if (!this.validatePassword.valid || this.passwordConfirmation.length <= 0 ) {
        return { state: 'none', valid: false, message: '' }
      } else if (this.inputPassword === this.passwordConfirmation) {
        return { state: 'valid', valid: true, message: '' }
      } else {
        return { state: 'invalid', valid: false, message: 'パスワードと同じではありません。'}
      }
    },

    allValid () {
      if (this.validatePassword.valid && this.validateConfirmation.valid) {
        return true
      }
      return false
    },
  },

  methods: {
    initData () {
      this.inputPassword = ''
      this.passwordConfirmation = ''
      this.passwordDisplay = false
    },

    togglePasswordDisplay () {
      this.passwordDisplay = !this.passwordDisplay
    },

    cancelEdit () {
      this.$emit('cancelEvent')
    },

    update () {
      if (this.allValid) {
        this.$emit('passwordUpdateEvent', this.inputPassword, this.passwordConfirmation)
      }
    },

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.password-edit-modal {
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
  }
  .modal-body {
    padding: 20px;
    input {
      font-size: 20px;
      width: calc(100% - 60px);
      border-radius: 5px;
      &.token-input {
        width: 100px;
      }
    }
  }  
}
</style>